import gql from 'graphql-tag';

export const LOGIN_MUTATION = gql`
  mutation LoginMutation(
    $companyId: ID
    $phone: String
    $email: String
    $username: String
    $password: String!
  ) {
    login(
      companyId: $companyId
      phone: $phone
      username: $username
      email: $email
      password: $password
    ) {
      error
      token
    }
  }
`;

export const CREATE_LOGIN_LINK = gql`
  mutation CreateLoginLink {
    createLoginLink {
      id
    }
  }
`;

export const GET_LOGIN_LINK = gql`
  query GetLoginLink($id: ID!) {
    LoginLink(id: $id) {
      id
      token
    }
  }
`;
